import mustafaAksitImg from '@/assets/mustafaaksit.jpg';
import hasanOzkanImg from '@/assets/hasanozkan.jpg';
import teamBerrakImg from '@/assets/nophoto.png';

export default function Team() {
  const teamMembers = [
    {
      name: "Mustafa Akşit",
      role: "President",
      bio: "Downing College 2012",
      image: mustafaAksitImg,
      linkedin: "https://www.linkedin.com/in/maksit/"
    },
    {
      name: "Dr. Hasan Özkan",
      role: "Secretary",
      bio: "Hughes Hall 2024",
      image: hasanOzkanImg,
      linkedin: "https://www.linkedin.com/in/hasan-ozkan-b1ab0475/"
    },
    {
      name: "Assoc. Prof. Dr. Berrak Teymur",
      role: "Board Member",
      bio: "Newnham College 1997",
      image: teamBerrakImg,
      linkedin: "https://akademi.itu.edu.tr/teymurb/"
    }
    /* Future team members - uncomment when needed:
    ,{
      name: "Can Arslan",
      role: "Mentorship Lead",
      bio: "Law LLM '12, Corporate lawyer specializing in international business",
      image: teamCanImg,
      linkedin: "#"
    },
    {
      name: "Zeynep Kaya",
      role: "Communications",
      bio: "History PhD '19, Museum curator and cultural heritage specialist",
      image: teamZeynepImg,
      linkedin: "#"
    },
    {
      name: "Emre Şahin",
      role: "Technology Lead",
      bio: "Computer Science MPhil '21, Software architect and AI researcher",
      image: teamEmreImg,
      linkedin: "#"
    }
    */
  ];

  return (
    <section id="team" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 
            className="text-3xl md:text-4xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Georgia, serif' }}
          >
            Our Founding Board and Committee
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Dedicated Cambridge alumni working to strengthen our community across Türkiye
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow">
              <img
                src={member.image}
                alt={member.name}
                className="w-full h-64 object-cover object-top"
                loading="lazy"
              />
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-teal-600 font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{member.bio}</p>
                <a 
                  href={member.linkedin}
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 transition-colors cursor-pointer"
                  aria-label={`${member.name} LinkedIn profile`}
                >
                  <i className="ri-linkedin-fill text-lg mr-2"></i>
                  <span className="text-sm font-medium">Connect</span>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
